import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizForm } = component_tool
const { WizContainer } = framework_tool

class Editor extends WizContainer {

    componentName = 'Editor'

    constructor(props) {
        super(props)
        this.state = {
            timestamp: new Date().getTime()
        }
    }

    _ok = () => {
        this.refs.form.validateFields((err, values) => {
            if (!err) {
                let { id, interviewState } = values
                this.doAction({
                    path: 'interviewResume/update',
                    payload: {
                        key: 'interviewResume@update',
                        apiParams: {
                            id,
                            interviewState
                        }
                    }
                })
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('操作成功')
            this.props.changeModal(false)
            let { editorSuccess } = this.props
            editorSuccess && editorSuccess()
        } else {
            wizNotice.error(nextProps.save.msg)
        }
    }

    render() {
        const { record = {} } = this.props
        const columns = [{
            name: 'id',
            dataIndex: 'id',
            formItem: {
                type: 'hidden'
            }
        }, {
            name: 'person',
            dataIndex: 'person',
            title: '面试人员',
            formItem: {
                type: 'custom',
                render: () => `${record.fullName} - ${record.positionName}`
            }
        }, {
            title: '面试结果',
            name: 'interviewState',
            dataIndex: 'interviewState',
            dict: [
                { code: 1, codeName: '通过' },
                { code: 2, codeName: '未通过' }
            ],
            formItem: {
                type: 'select',
                rules: [{ required: true, message: '请选择面试结果' }]
            }
        }]
        const formProps = {
            key: record.id || this.state.timestamp,
            ref: 'form',
            columns,
            record: { ...record, interviewState: record.interviewState === 0 ? undefined: record.interviewState },
            preview: false,
            footer: <div />,
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            }
        }

        return <WizForm {...formProps} />
    }
}

const mapStateToProps = (state, ownProps) => {
    const { interviewResume } = state
    const save = modelUtils.getModelEntity(interviewResume, 'interviewResume@update')
    return {
        save
    }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(Editor)


